
export class ProcessorConstant {}

